import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSavedSearches,
  createSavedSearch,
  updateSavedSearch,
  deleteSavedSearch,
} from "../Thunks/savedSearchesThunk";

const initialState = {
  list: [],
  loading: false,
  error: null,
  saving: false,
  saveError: null,
};

const savedSearchesSlice = createSlice({
  name: "savedSearches",
  initialState,
  reducers: {
    clearSavedSearches(state) {
      state.list = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchSavedSearches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSavedSearches.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchSavedSearches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "Failed to load saved searches";
      })

      // create
      .addCase(createSavedSearch.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(createSavedSearch.fulfilled, (state, action) => {
        state.saving = false;
        if (action.payload) {
          state.list = [action.payload, ...state.list];
        }
      })
      .addCase(createSavedSearch.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload ?? "Failed to save search";
      })

      // update
      .addCase(updateSavedSearch.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(updateSavedSearch.fulfilled, (state, action) => {
        state.saving = false;
        if (action.payload?.id) {
          state.list = state.list.map((s) => (s.id === action.payload.id ? action.payload : s));
        }
      })
      .addCase(updateSavedSearch.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload ?? "Failed to update search";
      })

      // delete
      .addCase(deleteSavedSearch.pending, (state) => {
        state.saving = true;
        state.saveError = null;
      })
      .addCase(deleteSavedSearch.fulfilled, (state, action) => {
        state.saving = false;
        state.list = state.list.filter((s) => s.id !== action.payload);
      })
      .addCase(deleteSavedSearch.rejected, (state, action) => {
        state.saving = false;
        state.saveError = action.payload ?? "Failed to delete search";
      });
  },
});

export const { clearSavedSearches } = savedSearchesSlice.actions;

export const selectSavedSearchList = (state) => state.savedSearches.list;
export const selectSavedSearchesLoading = (state) => state.savedSearches.loading;
export const selectSavedSearchesSaving = (state) => state.savedSearches.saving;

export default savedSearchesSlice.reducer;
